import { useState } from 'react'

export const useRerender = () => {
  const [, setTimestamp] = useState(0)
  const rerender = () => setTimestamp(Date.now())
  return () => setTimeout(rerender, 0)
}
